export default [
  {
    path: '/exchange/thirdlogin',
    name: 'ThirdLogin',
    component: (resolve) => require(['@/views/exchange/thirdLogin'], resolve)
  },
  {
    path: '/exchange/list',
    name: 'CourseList',
    component: (resolve) => require(['@/views/exchange/list'], resolve)
  },
  {
    path: '/exchange/exchange',
    name: 'Exchange',
    component: (resolve) => require(['@/views/exchange/exchange'], resolve)
  },
  {
    path: '/exchange/center',
    name: 'PersonalCenter',
    component: (resolve) => require(['@/views/exchange/center'], resolve)
  },
  {
    path: '/exchange/blanket',
    name: 'exchangeBlanket',
    component: (resolve) => require(['@/views/exchange/blanket'], resolve)
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/exchange.js